var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',[_c('h5',[_vm._v("Languages")]),_c('div',{staticClass:"d-flex justify-space-between"},[_c('span',{staticClass:"text-caption"},[_vm._v("Add your own translations or automatically translate your ad to reach people in more languages")]),_c('v-btn',{staticClass:"mt-5",attrs:{"small":""}},[_vm._v("Add Languages")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }